import { BrowserRouter } from "react-router-dom";

import "./App.css";
import AppRouter from "./router/AppRoutes2";
import ScrollToTop from "./router/ScrollToTop";
import "bootstrap/scss/bootstrap.scss";
import "./custom.scss";
import "./styles/theme-minimal.css";
import { getAppSettings } from "./api/api";
import { useEffect, Suspense } from "react";
import { handleError } from "./helpers/handleError";
function App() {
  const setFavicon = (iconUrl) => {
    // Remove existing favicon
    const existingLink = document.querySelector("link[rel='icon']");
    if (existingLink) {
      existingLink.parentNode.removeChild(existingLink);
    }

    // Create and add the new favicon
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = iconUrl;
    link.type = "image/x-icon";
    document.head.appendChild(link);
  };

  useEffect(() => {
    const fetchFavicon = async () => {
      try {
        const response = await getAppSettings();
        setFavicon(response.data?.info?.favicon);
      } catch (error) {
        handleError(error);
      }
    };

    fetchFavicon();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div>Cargando...</div>}>
        <AppRouter />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
